module.exports = __webpack_public_path__ + "static/media/ogl.0f145873.svg";